import React, { useRef } from 'react';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useCarContext } from '../components/Context/CarContext';
import { useSnackbar } from './SnackBar';
import { useProgressBar } from './ProgressBar';
const ModelForm = () => {
  const { models,brands,AddModel } = useCarContext();
  const { showSnackbar } = useSnackbar();
  const { showProgress } = useProgressBar();
  const modelNameRef = useRef('');
  const selectedBrandRef = useRef('');
  const formRef=useRef([]);
    const handleclick=()=>{
      const formElements=formRef.current.elements;
      for(let element of formElements){
       
        if(element.tagName==='INPUT' && element.type!='button'){
          element.style.borderColor='red'
        }else{
          element.style.borderColor='';
        }
      }

    };
    const emptyFieldCheck=(e)=>{
      if(e.target.value===""){
        e.target.style.borderColor='';
      }else{
        e.target.style.borderColor='';
      }
    }

  const handleAddModel = async () => {
    const modelName = modelNameRef.current.value.trim();
    const selectedBrand = selectedBrandRef.current.value;

    if (modelName === '' || selectedBrand === '') {
      showSnackbar('Model name and Brand selection cannot be empty.');
      handleclick();
      return;
    }

    const brand = brands.find((b) => b.id === selectedBrand);
    if (brand) {
      const existingModel = models.find(
        (m) =>
          m.brandId === selectedBrand &&
          m.name.toLowerCase() === modelName.toLowerCase()
      );
      if (existingModel) {
        showSnackbar('Model name already exists for this brand.');
        return;
      }
    }

    try {
      // Prepare the model data
      const modelData = {
        name: modelName,
        brandId: parseInt(selectedBrand), // Ensure brandId is a number
      };

      // Call AddModel with the necessary data
      showProgress(true);
      await AddModel(modelData);

      // Clear the input fields
      modelNameRef.current.value = '';
      selectedBrandRef.current.value = '';
      showProgress(false);
      showSnackbar('Model added successfully!'); // Notify success
    } catch (error) {
      showSnackbar('Error adding model. Please try again.');
      console.error('Error adding model:', error);
    }
  };
  return (
    <form ref={formRef}>
    <Box mb={4}>
     
      <Box display="flex" alignItems="center" gap={2}>
        <input
          label="Model Name"
          ref={modelNameRef}
          variant="outlined"
          fullWidth 
          sx={{ width:'300px' }}
          className="form-control"
          placeholder='Model Name'
          onBlur={(e)=>{
          emptyFieldCheck(e);
        }}/>
        <FormControl variant="outlined" fullWidth>
          
          <select
            labelId="select-brand-label"
            ref={selectedBrandRef}
            label="Select Brand"
            sx={{width:'300px' }}
            className="form-control"
          >
            <option>Select Brand</option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddModel}
          disabled={brands.length === 0}
        >
          Add Model
        </Button>
      </Box>
    </Box>
    </form>
  );
};

export default ModelForm;
